import { render, staticRenderFns } from "./ContactListIndex.vue?vue&type=template&id=37dc1328&scoped=true&"
import script from "./ContactListIndex.vue?vue&type=script&lang=js&"
export * from "./ContactListIndex.vue?vue&type=script&lang=js&"
import style0 from "./ContactListIndex.vue?vue&type=style&index=0&id=37dc1328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc1328",
  null
  
)

export default component.exports